import { createApp } from 'vue'
import App from './App.vue'
import './main.css'; // Import Tailwind styles

createApp(App).mount('#app')
